import React from 'react'
import { useTranslation } from 'react-i18next'

import MetricsSection from './MetricsSection'
import BreakdownSection from './BreakdownSection'
import LevelSection from './LevelSection'
import CustomEventsMetricsSection from './CustomEventsMetricsSection'
import CustomConversionsMetricsSection from './CustomConversionsMetricsSection'

import {
  CONVERSION_METRICS,
  conversionMetricsOptions,
  ENGAGEMENT_METRICS,
  engagementMetricsOptions,
  PERFORMANCE_METRICS,
  performanceMetricsOptions,
  VIDEO_METRICS,
  videoMetricsOptions
} from '../fields'

const ExportAsCsvReportFormContent = ({ formik, showLevelSelection, level }) => {
  const { t } = useTranslation()

  return (
    <>
      <MetricsSection
        title={t('Performance Metrics')}
        metricsGroupName={PERFORMANCE_METRICS}
        metrics={performanceMetricsOptions}
        formik={formik}
      />
      <MetricsSection
        title={t('Engagement Metrics')}
        metricsGroupName={ENGAGEMENT_METRICS}
        metrics={engagementMetricsOptions}
        formik={formik}
      />
      <MetricsSection
        title={t('Video Metrics')}
        metricsGroupName={VIDEO_METRICS}
        metrics={videoMetricsOptions}
        formik={formik}
      />
      <MetricsSection
        title={t('Conversion Metrics')}
        metricsGroupName={CONVERSION_METRICS}
        metrics={conversionMetricsOptions}
        formik={formik}
      />
      <CustomEventsMetricsSection formik={formik} />
      <CustomConversionsMetricsSection formik={formik} />
      {showLevelSelection && <LevelSection formik={formik} level={level} />}
      <BreakdownSection formik={formik} />
    </>
  )
}

export default ExportAsCsvReportFormContent
